import { ItinTag } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { useBoundStore } from "../../state/bound.store";
interface ITagsListProps {
  tagIds: number[];
}
export const ItinTagsList = ({ tagIds }: ITagsListProps) => {
  // The stored reference, not a defaulted copy: `?? []` inside the selector is a new array
  // on every call, and useShallow compares by identity, so the snapshot never settles.
  const tags = useBoundStore((s) => s.orgConfig?.itinTags);
  const selectedTags = useMemo(() => {
    return (tags ?? []).filter((tag) => tagIds.includes(tag.id)); // Filter tags based on tagIds
  }, [tags, tagIds]);

  return (
    <Stack
      direction="row"
      sx={{
        gap: "4px",
        flexWrap: "wrap",
      }}
    >
      {selectedTags.map((tag, index) => (
        <ItinTag tag={tag.name} colour={tag.colour} key={index} tagExpended />
      ))}
    </Stack>
  );
};
